import {
  FETCH_MESSAGES,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_FAILED,
  SEND_MESSAGE,
  STOP_FETCH_MESSAGES
} from "../store/types";
import store from '../store/store';
import { getSupabase } from '../config/configureSupabase';
import { RequestPushMsg } from '../other/NotificationFunctions';

let chatChannel = null;

export const fetchChatMessages = (bookingId) => (dispatch) => {
  dispatch({
    type: FETCH_MESSAGES,
    payload: bookingId,
  });

  const supabase = getSupabase();
  if (supabase) {
    const loadMessages = async () => {
      try {
        const { data, error } = await supabase
          .from('chat_messages')
          .select('*')
          .eq('booking_id', bookingId)
          .order('created_at', { ascending: true });

        if (!error && data) {
          dispatch({
            type: FETCH_MESSAGES_SUCCESS,
            payload: data,
          });
          return;
        }
      } catch (e) {}
    };

    loadMessages();

    if (chatChannel) {
      supabase.removeChannel(chatChannel);
    }
    chatChannel = supabase
      .channel(`public:chat_messages:${bookingId}`)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'chat_messages', filter: `booking_id=eq.${bookingId}` }, (payload) => {
        dispatch({
          type: SEND_MESSAGE,
          payload: payload.new,
        });
      })
      .subscribe();
    return;
  }

  dispatch({
    type: FETCH_MESSAGES_SUCCESS,
    payload: []
  });
};

export const sendMessage = (data) => async (dispatch) => {
  const today = new Date();
  const time = today.getHours() + ":" + today.getMinutes();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0'); 
  const yyyy = today.getFullYear();
  const dateStr = mm + ':' + dd + ':' + yyyy;

  const msg = {
    booking_id: data.booking.id,
    message: data.message,
    from: data.role === 'customer' ? data.booking.customer : data.booking.driver,
    type: "msg",
    msgDate: dateStr,
    msgTime: time,
    createdAt: new Date().toISOString(),
    source: data.role
  };

  dispatch({
    type: SEND_MESSAGE,
    payload: msg,
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      await supabase.from('chat_messages').insert([msg]);
    } catch (e) {}
  }

  if (data.role === 'customer' && data.booking.driver_token) {
    RequestPushMsg(data.booking.driver_token, {
      title: (store.getState().languagedata?.defaultLanguage?.notification_title || '') + (store.getState().languagedata?.defaultLanguage?.chat_requested || ' Nova mensagem'),
      msg: data.message,
      screen: 'onlineChat',
      params: { bookingId: data.booking.id }
    });
  } else if (data.booking.customer_token) {
    RequestPushMsg(data.booking.customer_token, {
      title: (store.getState().languagedata?.defaultLanguage?.notification_title || '') + (store.getState().languagedata?.defaultLanguage?.chat_requested || ' Nova mensagem'),
      msg: data.message,
      screen: 'onlineChat',
      params: { bookingId: data.booking.id }
    });
  }
};

export const stopFetchMessages = (bookingId) => () => {
  const supabase = getSupabase();
  if (supabase && chatChannel) {
    supabase.removeChannel(chatChannel);
    chatChannel = null;
  }
};